import { VarImg } from './VarImg';
import { motion } from 'framer-motion';
import styles from './VariantsImg.module.css';

export const VariantsImg = ({ variants, varNumFontSize, currentState }) => {
  return (
    <div className={styles.wrapper}>
      {variants &&
        variants.map((v, i) => (
          <motion.div
            key={v.varImgUrl + i}
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1, delay: 2.5 + i * 0.8 }}>
            <VarImg
              item={v}
              varNumFontSize={varNumFontSize}
              currentState={currentState}
            />
          </motion.div>
        ))}
    </div>
  );
};
